const TrackerbaseLoginViewModuleConstants = Object.freeze({
    rootStateName: "NotAuthorized",
    prevStateLabel: null
});

export default TrackerbaseLoginViewModuleConstants;



//////////////////
// WEBPACK FOOTER
// ./src/views/tb-login-view/Constants.js
// module id = 9XF+
// module chunks = 1